<template>
    <g>
        <circle cx="8" cy="8" r="7.5" fill="white" stroke="#C8D0DD" />
    </g>
</template>
<script>
export default {
    name: "RadioUnChecked",
};
</script>
